<template>
  <div>
    <br />
    <form @submit.prevent="save(saleItem)">
      <div class="row align-items-end">
        <div class="col-xl-3 col-12 my-3">
          <label for="itemInput">Produit</label>
          <vue-select
            :options="filteredItems"
            v-model="saleItem.item_reference"
            placeholder="Select an option"
            labelColumn="fullName"
            valueColumn="reference"
          />
        </div>

        <div class="col-xl col-6 my-3">
          <label for="">Quantité</label>
          <input
            v-model="saleItem.quantity"
            class="form-control"
            type="number"
          />
        </div>

        <div class="col-xl col-6 my-3">
          <label for="">Prix HT</label>
          <input
            v-model="saleItem.priceHT"
            class="form-control"
            type="number"
            step="0.01"
          />
        </div>

        <div class="col-xl col-6 my-3">
          <label for="">Prix TTC</label>
          <input
            v-model="saleItem.priceTTC"
            class="form-control"
            type="number"
            step="0.01"
          />
        </div>

        <div class="col-xl col-12 my-3">
          <label for=""> Remarque </label>
          <input v-model="saleItem.remark" class="form-control" />
        </div>
      </div>

      <hr />
      <div class="row justify-content-end">
        <div class="col-xl-auto col-6">
          <label for=""></label>
          <button class="btn btn-success shadow" type="submit">
            <i class="bi bi-plus-circle"></i> Insérer
          </button>
        </div>

        <div class="col-xl-auto col-6">
          <label for=""></label>
          <button
            type="button"
            class="btn btn-secondary d-flex align-items-center"
            @click="refresh()"
          >
            <i class="bi bi-arrow-clockwise fs-4 me-2"></i>
            <span> Actualiser </span>
          </button>
        </div>
      </div>
    </form>
    <br />
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th scope="col">Nº</th>
          <th scope="col">Désignation</th>
          <th scope="col">Prix HT</th>
          <th scope="col">Prix TTC</th>
          <th scope="col">Quantité</th>
          <th scope="col">Total HT</th>
          <th scope="col">Total TTC</th>
          <th scope="col">Remarque</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in saleItems" :key="index++">
          <td>{{ index + 1 }}</td>
          <td>
            <span v-if="item.item">
              {{ item.item.fullName }}
            </span>
          </td>
          <td>{{ item.priceHT }}</td>
          <td>{{ item.priceTTC }}</td>
          <td>{{ item.quantity }}</td>
          <td>{{ item.totalPriceHT }}</td>
          <td>{{ item.totalPriceTTC }}</td>
          <td>{{ item.remark }}</td>
          <td class="d-flex">
            <button @click="remove(item.id)" class="btn text-danger">
              <i class="bi bi-trash-fill"></i>
            </button>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr class="border-0">
          <td></td>
          <td>Total :</td>
          <td></td>
          <td></td>
          <td>
            <span class="fw-bold bg-warning px-2 py-1 rounded">
              {{ parseFloat(totalQuantityItems).toFixed(2) }}
            </span>
          </td>
          <td>
            <span class="fw-bold bg-warning px-2 py-1 rounded">
              {{ parseFloat(totalPriceHTItems).toFixed(2) }}
            </span>
            DH
          </td>
          <td>
            <span class="fw-bold bg-warning px-2 py-1 rounded">
              {{ parseFloat(totalPriceTTCItems).toFixed(2) }}
            </span>
            DH
          </td>
          <td></td>
          <td></td>
        </tr>
      </tfoot>
    </table>
    <br />
    <div class="row mt-3 justify-content-between align-items-center">
      <div class="col-xl-8 col-12"></div>
      <div class="col-xl-auto col-12">
        <button class="btn btn-primary" @click="next()">
          <i class="bi bi-arrow-right-circle"></i> Suivant
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      saleItem: {
        user_reference: null,
      },
    };
  },
  computed: {
    ...mapGetters("item", {
      items: "getAll",
    }),
    ...mapGetters("sellerSale", {
      saleItems: "getItems",
      totalQuantityItems: "totalQuantityItems",
      totalPriceTTCItems: "totalPriceTTCItems",
      totalPriceHTItems: "totalPriceHTItems",
      numberItems: "numberItems",
    }),
    ...mapGetters("auth", {
      user: "getAuthData",
    }),

    filteredItems() {
      return this.items;
    },
  },
  methods: {
    async save(data) {
      if (!data.item_reference || !data.quantity || !data.priceTTC) {
        alert("Veuillez remplir tous les champs obligatoires");
        return;
      }
      data.totalPriceHT = (
        parseFloat(data.priceHT || 0) * parseFloat(data.quantity)
      ).toFixed(2);
      data.totalPriceTTC = (
        parseFloat(data.priceTTC || 0) * parseFloat(data.quantity)
      ).toFixed(2);
      data.user_reference = this.user && this.user.reference;
      await this.$store.dispatch("sellerSale/storeItem", data);
      this.saleItem = { user_reference: this.user && this.user.reference };
    },

    async remove(id) {
      await this.$store.dispatch("sellerSale/destroyItem", id);
    },

    async refresh() {
      this.$store.dispatch("sellerSale/getAllItems");
    },
    async next() {
      if (this.numberItems > 0) {
        this.$router.push({ name: "seller-sales-create" });
      } else {
        alert("Veuillez ajouter au moins un article");
      }
    },
  },
  beforeMount() {
    this.$store.dispatch("sellerSale/getAllItems");
    this.$store.dispatch("item/getAll");
  },
};
</script>
